<div>
  <portal-breadcrumbs [isHeader]="true"></portal-breadcrumbs>
</div>
<div>
  <portal-layout-audio-partial></portal-layout-audio-partial>
  <portal-layout-audio-recorded></portal-layout-audio-recorded>
  <portal-user *ngIf="isLoggedIn"></portal-user>
</div>
